module.exports = __webpack_public_path__ + "img/simple6.35d5f97a.png";